import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PersonalAccountState } from './types';

// deprecated. don't save token to store. get it from accountJWT
const initialState: PersonalAccountState = {
  userEndpointToken: undefined,
  workerToken: undefined,
};

export const personalAccountSlice = createSlice({
  name: 'personalAccount',
  initialState,
  reducers: {
    // deprecated. don't save token to store. get it from accountJWT
    setUserEndpointToken: (
      state,
      action: PayloadAction<PersonalAccountState['userEndpointToken']>,
    ) => {
      state.userEndpointToken = action.payload;
    },
    // deprecated. don't save token to store. get it from accountJWT
    setWorkerToken: (
      state,
      action: PayloadAction<PersonalAccountState['workerToken']>,
    ) => {
      state.workerToken = action.payload;
    },
    resetPersonalAccountSlice: () => initialState,
  },
});

export const { resetPersonalAccountSlice } = personalAccountSlice.actions;
